import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import { bindGa } from 'helpers/analytics';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import s from './NotificationCenter.scss';
import { rodate } from '../../utils/common';

class NotificationCenter extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    theme: PropTypes.string,
    colorTheme: PropTypes.string,
  };

  static defaultProps = {
    theme: '',
    colorTheme: '',
  };

  constructor() {
    super();
    this.state = {
      showNotifications: false,
      isOpened: false,
      showNotificationsCount: true,
    };

    this.notificationCount = 0;
    this.storageKey = 'ntCentre_showTime';
    this.toggleNotifications = this.toggleNotifications.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('click', this.handleClickEventListener);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleClickEventListener);
  }

  handleClickEventListener = e => {
    const widget = document.getElementById('notification-center-wdt');
    const elemClass = e.target.className || '';
    if (
      (widget && widget.contains(e.target)) ||
      (typeof elemClass !== 'string' ||
        elemClass.indexOf(`${s.sprite_bg}`) !== -1)
    ) {
      return;
    }

    if (this.state.showNotifications) {
      this.setState({ showNotifications: false });
    }
  };

  @bindGa({})
  toggleNotifications(e) {
    e.stopPropagation();
    const isOpen = this.state.showNotifications;
    const firstTimeOpen = this.state.isOpened;
    const stateObj = {
      showNotifications: !this.state.showNotifications,
      showNotificationsCount: false,
    };

    if (!isOpen && !firstTimeOpen) {
      stateObj.isOpened = true;
    }
    this.setState(stateObj, () =>
      this.setLocalStorage(!isOpen && !firstTimeOpen),
    );
    sendGaThroughProps({
      data: {
        gaCategory: 'top_header',
        gaAction: 'top_header',
        gaLabel: isOpen ? 'close' : 'open',
      },
    });
  }

  setLocalStorage = setstorage => {
    if (setstorage) {
      try {
        localStorage.setItem(this.storageKey, Date.now());
      } catch (e) {
        // console.log(e)
      }
    }
  };

  shouldMarkActive = msgTime => {
    let lastShowTime;
    try {
      lastShowTime = localStorage.getItem(this.storageKey);
    } catch (e) {
      // console.log(e)
    }

    if (msgTime > lastShowTime) {
      return true;
    }

    return false;
  };

  getListData(obj) {
    const isActive = this.shouldMarkActive(obj.bnupdatetime);

    if (isActive) {
      this.notificationCount = this.notificationCount + 1;
    }
    return (
      <a href={obj.path} className={isActive ? s.active : ''}>
        <div className={`${s.notifylist} `}>
          <div className={s.ntMsgInnerBox}>
            <div className={s.text}>{rodate(obj.bnupdatetime)}</div>
            <div className={`${s.text} ${s.jNtText}`}>
              {`${obj.title ? `${obj.title}: ` : ''}${obj.message}`}
            </div>
          </div>
        </div>
      </a>
    );
  }

  getList(data) {
    this.notificationCount = 0;
    const returnHtml = data.map((obj, index) => (
      <React.Fragment key={index}>{this.getListData(obj)}</React.Fragment>
    ));

    return returnHtml;
  }

  render() {
    const listItems = this.getList(this.props.data);
    const { colorTheme } = this.props;
    const theme = colorTheme;

    return (
      <span
        className={`${s.noticnt} ${
          this.props.theme ? s[this.props.theme] : ''
        }`}
      >
        <span className={s.jNtBell}>
          <span
            className={`${s.sprite_bg} ${s.nt} ${s[theme]}`}
            onClick={this.toggleNotifications}
          />
          {this.state.showNotificationsCount &&
            this.notificationCount > 0 && (
              <span className={s.count}>{this.notificationCount}</span>
            )}
        </span>
        {this.state.showNotifications && (
          <div
            id="notification-center-wdt"
            className={`${s.gdnotification} ${s.noimageNt}`}
          >
            <div className={`${s.gnnotifyouter}`}>
              <span
                className={s.closeicon}
                onClick={this.toggleNotifications}
              />
              <div className={s.notification_title}>Notification Center</div>
              <Scrollbars
                style={{
                  width: 350,
                  height: 235,
                }}
                universal
              >
                <div className={`${s.jNtList} ${s.notificationmessage}`}>
                  {listItems}
                </div>
              </Scrollbars>
            </div>
          </div>
        )}
      </span>
    );
  }
}

export default NotificationCenter;
